import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import ErrorState from '../../../common/errorState/errorState';

import { ticketListMessages } from '../../../../constants/Messages';

import ProductListSkeleton from '../../mis-compras/components/loadingState/productListSkeleton';
import EmptyState from '../emptyState/EmptyState';
import Ticket from './Ticket';
import { useTicketContainerStyles } from './styles';

const TicketsContainer = (props) => {
  const { mobile, tickets, ticketStatus } = props;
  const classes = useTicketContainerStyles();

  return (
    <React.Fragment>
      <Box className={classes.container}>
        {ticketStatus === 'loading' && <ProductListSkeleton mobile={mobile} />}
        {ticketStatus === 'succeded' && (
          <React.Fragment>
            <Box
              display="grid"
              gridRowGap="10px"
              className={classes.ticketListContainer}
            >
              {tickets.map((ticket, index) => (
                <Ticket
                  key={index}
                  index={index}
                  ticket={ticket}
                  mobile={mobile}
                />
              ))}
            </Box>
          </React.Fragment>
        )}
        {ticketStatus === 'notFound' && <EmptyState />}
        {ticketStatus === 'error' && (
          <ErrorState mobile={mobile} title={ticketListMessages.error} />
        )}
      </Box>
    </React.Fragment>
  );
};

TicketsContainer.propTypes = {
  mobile: PropTypes.bool,
  tickets: PropTypes.array,
  ticketStatus: PropTypes.string,
};

export default TicketsContainer;
